



























































import {Component, Prop, Vue} from "vue-property-decorator";
import LabelCount from "@/views/Service/TimeTracking/Customers/Overview/Customer/LabelCount.vue";

@Component({
  components: {LabelCount}
})
export default class Customer extends Vue {
  public name: string = "Customer";

  @Prop({required: true})
  private customer!: any;

  private cardClick(): void {
    // removed console_log
    if (this.customer) {
      this.$router.push({name: 'TimeTracking-Overview-Customer', params: {id: this.customer.id}});
    }
  }


}
